export default props => (
  props.test ? props.children : false
);



// WEBPACK FOOTER //
// ./src/lib_react_frontend/componentes/IF.jsx